// نظام التقويم لكل فرع: هجري / ميلادي شامي-عراقي / ميلادي معرّب دولي، مع اشتقاق تلقائي من المنطقة الزمنية.
export const CAL_SYSTEMS = ["auto", "hijri", "greg_levant", "greg_intl"];

// مناطق زمنية تُحدِّد النظام تلقائياً حين يكون الفرع على "auto".
const HIJRI_TZ = ["Riyadh", "Mecca", "Makkah"];
const LEVANT_TZ = ["Baghdad", "Damascus", "Beirut", "Amman", "Hebron", "Gaza", "Jerusalem"];

export const resolveSystem = (stored, tz = "") => {
  if (stored && stored !== "auto") return stored;
  const z = tz || "";
  if (HIJRI_TZ.some((c) => z.includes(c))) return "hijri";
  if (LEVANT_TZ.some((c) => z.includes(c))) return "greg_levant";
  return "greg_intl";
};

// الموضع المناسب لكل نظام في Intl — أرقام لاتينية دائماً.
export const localeFor = (system, lang = "en") => {
  if (system === "hijri") return lang === "ar" ? "ar-SA-u-ca-islamic-umalqura-nu-latn" : "en-u-ca-islamic-umalqura";
  if (system === "greg_levant") return lang === "ar" ? "ar-IQ-u-nu-latn" : "en-GB";
  if (system === "greg_intl") return lang === "ar" ? "ar-EG-u-nu-latn" : "en-GB";
  return lang === "ar" ? "ar-AE-u-nu-latn" : "en-GB";
};
